import { render, staticRenderFns } from "./CommissioningActivation.vue?vue&type=template&id=0677bf9d"
import script from "./CommissioningActivation.vue?vue&type=script&lang=js"
export * from "./CommissioningActivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports